import { render, staticRenderFns } from "./MarketingView.vue?vue&type=template&id=72da6a6a&scoped=true&"
import script from "./MarketingView.vue?vue&type=script&lang=js&"
export * from "./MarketingView.vue?vue&type=script&lang=js&"
import style0 from "./MarketingView.vue?vue&type=style&index=0&id=72da6a6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72da6a6a",
  null
  
)

export default component.exports